@let collapsed = layoutService.isMenuCollapsed();

<!-- INFO (Denis) - burger button shown on mobile devices; fixed, so it may overlap the page content -->
<div class="lg:hidden fixed top-3 left-3 z-[996]">
  <p-button
    icon="pi pi-bars"
    severity="secondary"
    [raised]="true"
    [ariaLabel]="'layout.openMenu' | translate"
    (onClick)="layoutService.onMenuToggle()"
  />
</div>

<app-loader [name]="appMenuComponentLoader" [backgroundClass]="'rounded-md-xl'" [loaderContainerClass]="'h-full'">
  <div class="layout-sidebar flex flex-col">
    <a
      routerLink="/app/dashboard"
      class="flex shrink-0 items-center gap-2 pt-2 pb-3 mb-2 border-b border-surface-200 text-3xl font-medium text-color no-underline"
      [class.justify-center]="collapsed"
      [attr.aria-label]="'layout.appLogo' | translate"
      [pTooltip]="'layout.appLogo' | translate"
      showDelay="800"
      [tooltipPosition]="collapsed ? 'right' : 'bottom'"
    >
      <img src="assets/layout/images/logo.svg" alt="" [class]="collapsed ? 'h-8' : 'h-10'" />

      @if (!collapsed) {
        <span>SWI</span>
      }
    </a>

    <ul class="layout-menu flex flex-1 min-h-0 flex-col overflow-y-auto">
      @if (showSubscriptionCard()) {
        <li>
          <app-subscription-card />
        </li>
      }

      @for (entry of menuEntries(); track entry.index) {
        @if (entry.item.separator) {
          <li class="menu-separator"></li>
        } @else if (entry.visible) {
          <li app-menuitem [item]="entry.item" [index]="entry.index" [root]="true"></li>
        }
      }
    </ul>

    <div class="flex shrink-0 flex-col gap-2 pt-3 mt-2">
      <app-profile-menu [collapsed]="collapsed" />

      <div class="flex items-center mt-4" [class]="collapsed ? 'justify-center' : 'justify-between'">
        @if (!collapsed) {
          <app-scale />

          <code class="rounded-md bg-surface-100 px-2 py-0.5 font-mono text-xs text-muted-color">
            v{{ currentVersion }}
          </code>
        }

        <p-button
          [icon]="collapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"
          severity="secondary"
          [rounded]="true"
          [text]="true"
          [ariaLabel]="(collapsed ? 'layout.openMenu' : 'layout.closeMenu') | translate"
          [pTooltip]="(collapsed ? 'layout.openMenu' : 'layout.closeMenu') | translate"
          showDelay="800"
          [tooltipPosition]="collapsed ? 'right' : 'top'"
          (click)="layoutService.onMenuToggle()"
        />
      </div>
    </div>
  </div>
</app-loader>

<!-- INFO (Denis) - Mode switcher temporarily disabled until dark-mode is properly tested and adjusted -->
<!-- <p-button
          [rounded]="true"
          variant="text"
          class="p-button-lg"
          (click)="layoutService.onToggleDarkMode()"
          pTooltip="{{ 'layout.darkMode' | translate }}"
          showDelay="800"
          tooltipPosition="top"
          icon="pi pi-moon"
        /> -->
